import { ReactElement } from 'react';

import { StyledFlex } from '@dreryk/react-components';
import { TranslatableText, Translate } from '@dreryk/react-common';

import { PatientNfzDepartmentForm } from './form/PatientNfzDepartmentForm';
import { PatientNfzDepartmentUpdateModalConfirmButton } from './PatientNfzDepartmentUpdateModalConfirmButton';
import { PatientNfzDepartmentUpdateModalCancelButtons } from './PatientNfzDepartmentUpdateModalCancelButtons';

type PatientNfzDepartmentUpdateModalContentProps = {
   modalLabel: TranslatableText;
   patientId: number;
   onSuccess: VoidFunction;
   onFault: VoidFunction;
   onCancel: VoidFunction;
};

export const PatientNfzDepartmentUpdateModalContent = (
   props: PatientNfzDepartmentUpdateModalContentProps
): ReactElement => {
   return (
      <StyledFlex gap={'18px'} direction={'column'}>
         <Translate>{props.modalLabel}</Translate>
         <PatientNfzDepartmentForm>
            {({ handleSubmit, formState }) => (
               <>
                  <PatientNfzDepartmentUpdateModalConfirmButton
                     patientId={props.patientId}
                     handleSubmit={handleSubmit}
                     onSuccess={props.onSuccess}
                     onFault={props.onFault}
                  />
                  <PatientNfzDepartmentUpdateModalCancelButtons
                     onClick={props.onCancel}
                     shouldConfirmExit={formState.isDirty}
                  />
               </>
            )}
         </PatientNfzDepartmentForm>
      </StyledFlex>
   );
};
